import { useTruckerProps } from 'hooks/useTruckerProps';

const useDispatchToParent = () => {
  const { dispatchToCaller } = useTruckerProps();
  const dispatchToParent = (props: { type: string; payload?: unknown }): void => {
    dispatchToCaller?.(props);
  };

  return { dispatchToParent };
};

export { useDispatchToParent };
